module.exports = __webpack_public_path__ + "static/media/center.a1143ab6.svg";